import * as React from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import image1 from "../images/santacruz/image1.jpg";
import image2 from "../images/santacruz/image2.jpg";
import image3 from "../images/santacruz/image3.jpg";
import image4 from "../images/santacruz/image4.jpg";
import image5 from "../images/santacruz/image5.jpg";
import image6 from "../images/santacruz/image6.jpg";

export default function GaleriaSantaCruz() {
  const [screenSize, setScreenSize] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  React.useEffect(() => {
    // Función para actualizar el tamaño de la pantalla
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    // Agregar el evento de redimensionamiento
    window.addEventListener("resize", handleResize);

    // Eliminar el evento para evitar fugas de memoria
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <ImageList
      sx={{
        height: 450,
      }}
      cols={screenSize.width >= 600 ? 3 : 2}
      rowHeight={200}
    >
      {itemData.map((item) => (
        <ImageListItem key={item.img}>
          <img
            srcSet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
            src={`${item.img}?w=164&h=164&fit=crop&auto=format`}
            alt={item.title}
            loading="lazy"
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
}

const itemData = [
  {
    img: image1,
    title: "Ambientes DLS La Paz",
  },
  {
    img: image2,
    title: "Burger",
  },
  {
    img: image3,
    title: "Camera",
  },
  {
    img: image4,
    title: "Coffee",
  },
  {
    img: image5,
    title: "Hats",
  },
  {
    img: image6,
    title: "Honey",
  },
];
